<template>
  <b-alert
    :show="changedSections.length > 0"
    variant="warning"
  >
    <h5>
      <font-awesome-icon
        :icon="['fas', 'exclamation-triangle']"
        class="mr-2"
      />
      Please note
    </h5>
    You have updated the following {{ changedSections.length > 1 ? 'sections' : 'section' }}:
    <ul>
      <li
        v-for="section in changedSections"
        :key="section"
      >
        {{ section }}
      </li>
    </ul>
    <strong><u>Traffic will be paused on this buyer campaign until it is reviewed and approved by an admin again.</u></strong>
  </b-alert>
</template>

<script>
export default {
  name: 'UpdateCampaignAlert',

  props: {
    changedSections: {
      type: Array,
      default: () => []
    }
  },
}
</script>

<style lang="">

</style>
